module.exports = __webpack_public_path__ + "img/202411_07.88d38ea4.jpg";